import React from 'react';
import StageSummary from './StageSummary';
import { Statistics } from './Home';
import { CategoryLink } from './categoryLink';
import {
  StageStatisticsStatus,
  StatisticValue,
  studiesNoun,
} from './stageStatistics';

type FullTextScreeningProps = {
  reviewerName: string;
  excluded: number;
  stats: Statistics;
  status: StageStatisticsStatus;
  isOpen: boolean;
};

const FullTextScreening = ({
  isOpen,
  excluded,
  reviewerName,
  stats,
  status,
}: FullTextScreeningProps) => {
  const secondaryContent = `${excluded} excluded`;
  const studyCategoryCount = (
    <>
      <StatisticValue status={status.counters} value={stats?.available} />{' '}
      {studiesNoun(status.counters, stats?.available)} to screen
    </>
  );

  return (
    <StageSummary
      isOpen={isOpen}
      stage="select"
      title="Full text review"
      secondaryContent={secondaryContent}
      secondaryLink={CategoryLink('excluded')}
      studyCategoryCount={studyCategoryCount}
      studyCategoryLink={CategoryLink('select')}
      reviewerName={reviewerName}
      stats={stats}
      status={status}
    />
  );
};

export default FullTextScreening;
